(() => {
  const initStickyAtc = () => {
    const sticky = document.querySelector('[data-tcc-sticky-atc]');
    if (!sticky || sticky.dataset.initialized === 'true') return;

    const form = document.getElementById(sticky.dataset.formId);
    const primaryButton = form?.querySelector('[id^="ProductSubmitButton-"]');
    const stickyButton = sticky.querySelector('[data-tcc-sticky-submit]');
    const stickyLabel = sticky.querySelector('[data-tcc-sticky-label]');

    if (!form || !primaryButton || !stickyButton) return;
    sticky.dataset.initialized = 'true';

    const syncState = () => {
      const unavailable = primaryButton.disabled;
      stickyButton.disabled = unavailable;
      if (stickyLabel) {
        stickyLabel.textContent = primaryButton.querySelector('span')?.textContent.trim() || stickyLabel.textContent;
      }
    };

    const observer = new MutationObserver(syncState);
    observer.observe(primaryButton, { attributes: true, childList: true, subtree: true });
    form.addEventListener('change', syncState);
    syncState();

    const setVisibility = (isVisible) => {
      sticky.hidden = isVisible || window.matchMedia('(min-width: 750px)').matches;
    };

    if ('IntersectionObserver' in window) {
      const intersectionObserver = new IntersectionObserver(
        ([entry]) => setVisibility(entry.isIntersecting),
        { threshold: 0.15 }
      );
      intersectionObserver.observe(primaryButton);
    } else {
      setVisibility(true);
    }

    window.addEventListener('resize', () => setVisibility(primaryButton.getBoundingClientRect().top < window.innerHeight));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', initStickyAtc);
})();